var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{style:(_vm.activeTab==_vm.id?_vm.activeStyle:_vm.style),attrs:{"href":"javascript:void(0)"},on:{"click":_vm.onClick}},[_c('font-awesome-icon',{staticStyle:{"font-size":"20px","margin-top":"8px"},attrs:{"icon":_vm.icon}}),_c('div',{staticStyle:{"font-size":"12px","margin-top":"2px"}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }